export const base = {
  NAME_PROJECT: 'banzai',
};
